import React from 'react';

const ICON = (path) => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {path}
  </svg>
);

export const JW_ICONS = {
  enroll: ICON(<><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><line x1="19" y1="8" x2="19" y2="14" /><line x1="22" y1="11" x2="16" y2="11" /></>),
  book: ICON(<><path d="M2 4h7a4 4 0 014 4v12a3 3 0 00-3-3H2z" /><path d="M22 4h-7a4 4 0 00-4 4v12a3 3 0 013-3h8z" /></>),
  training: ICON(<><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /><polyline points="9 8 7 11 9 14" /><polyline points="15 8 17 11 15 14" /></>),
  assessment: ICON(<><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" /></>),
  project: ICON(<><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></>),
  capstone: ICON(<><path d="M4.5 16.5c-1.5 1.5-2 5-2 5s3.5-.5 5-2c.83-.83 1-2.17.17-3.17a2.43 2.43 0 00-3.17-.17z" /><path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" /></>),
  team: ICON(<><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" /></>),
  review: ICON(<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><circle cx="11" cy="15" r="2.5" /><line x1="13" y1="17" x2="15" y2="19" /></>),
  certificate: ICON(<><circle cx="12" cy="8" r="6" /><path d="M9 13.5L7 22l5-3 5 3-2-8.5" /></>),
  placement: ICON(<><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" /></>),
  resume: ICON(<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="13" y2="17" /></>),
  interview: ICON(<><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" /></>),
  target: ICON(<><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></>),
  communication: ICON(<><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></>),
};

/**
 * Reusable horizontal "Journey Workflow" diagram.
 * steps: [{ label: string, icon: keyof JW_ICONS, color: string }]
 */
const JourneyWorkflow = ({ title = 'Journey Workflow', steps = [], accentColor = '#2563EB' }) => {
  return (
    <section style={{ padding: '0 4% 56px' }}>
      <div className="jw-card" style={{ '--jw-accent': accentColor }}>
        <h2 className="jw-title">{title}</h2>
        <div className="jw-track-wrap">
          <div className="jw-track">
            {steps.map((s, i) => (
              <React.Fragment key={s.label}>
                {i > 0 && (
                  <div className="jw-connector">
                    <span className="jw-dot" style={{ background: steps[i - 1].color }} />
                    <span className="jw-line" style={{ background: `linear-gradient(90deg, ${steps[i - 1].color}, ${s.color})` }} />
                    <span className="jw-dot" style={{ background: s.color }} />
                  </div>
                )}
                <div className="jw-node">
                  <div className="jw-circle" style={{ background: `linear-gradient(135deg, ${s.color}, ${s.color}CC)` }}>
                    {JW_ICONS[s.icon]}
                  </div>
                  <div className="jw-label">{s.label}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .jw-card { max-width:1280px; margin:0 auto; background:linear-gradient(180deg,#F8FAFC,#F1F5F9); border:1px solid #E2E8F0; border-radius:20px; padding:36px 24px 30px; }
        .jw-title { text-align:center; font-size:clamp(20px,3vw,28px); font-weight:900; color:#0F172A; margin:0 0 36px; letter-spacing:-0.01em; }
        .jw-track-wrap { overflow:visible; }
        .jw-track { display:flex; align-items:flex-start; flex-wrap:wrap; row-gap:28px; margin:0 auto; justify-content:center; }
        .jw-node { display:flex; flex-direction:column; align-items:center; width:90px; flex-shrink:0; }
        .jw-circle { width:56px; height:56px; border-radius:50%; display:flex; align-items:center; justify-content:center; box-shadow:0 6px 14px rgba(15,23,42,0.12); }
        .jw-circle svg { width:24px; height:24px; }
        .jw-label { margin-top:12px; font-size:12px; font-weight:800; color:#1E293B; text-align:center; line-height:1.35; }
        .jw-connector { display:flex; align-items:center; flex:1 1 16px; min-width:12px; max-width:48px; height:56px; }
        .jw-line { height:2px; flex:1; }
        .jw-dot { width:7px; height:7px; border-radius:50%; flex-shrink:0; }
        @media(max-width:900px) { .jw-connector { max-width:28px; } .jw-node { width:80px; } }
        @media(max-width:600px) { .jw-card { padding:28px 14px 22px; } .jw-node { width:70px; } .jw-circle { width:48px; height:48px; } .jw-circle svg { width:20px; height:20px; } .jw-connector { max-width:18px; min-width:8px; } .jw-label { font-size:10.5px; } }
      `}</style>
    </section>
  );
};

export default JourneyWorkflow;
